module.exports = __webpack_public_path__ + "img/favorites.ac26f4b9.png";